import React from 'react'
import { Table } from 'react-bootstrap'

export default function DataTable({ data, columns, sort, onSort, header, footer, row, selected, onSelect, disabled, ...rest}) {

  const handleSelect = (item) => (() => onSelect(item));

  return (
    <Table {...rest}>
      { header &&
        <thead>
          {header({ columns, sort, onSort })}
        </thead>
      }
      <tbody>
        {data.map((item, index) => {
          const isSelected = item === selected;
          return row({ index, rowData: item, columns, onClick: (!disabled && onSelect) && handleSelect(item), isSelected })
        }
          
        )}
      </tbody>
      {footer &&
        <tfoot>
          {footer}
        </tfoot>
      }
    </Table>
  )
}
